/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type TierStepsResponseDTO = {
  stepName?: TierStepsResponseDTO.stepName;
  stepNumber?: number;
  stepStatus?: TierStepsResponseDTO.stepStatus;
  rejectionReason?: string;
};

export namespace TierStepsResponseDTO {
  export enum stepName {
    START_PAGE_TIERS_STEP = "START_PAGE_TIERS_STEP",
    SELFIE_VERIFICATION_STEP = "SELFIE_VERIFICATION_STEP",
    NIN_VERIFICATION_STEP = "NIN_VERIFICATION_STEP",
    NEXT_OF_KIN_STEP = "NEXT_OF_KIN_STEP",
    DOCUMENT_VERIFICATION_STEP = "DOCUMENT_VERIFICATION_STEP",
    BUSINESS_ADDRESS_STEP = "BUSINESS_ADDRESS_STEP",
    REGISTRATION_DETAILS_STEP = "REGISTRATION_DETAILS_STEP",
    BUSINESS_DETAILS_STEP = "BUSINESS_DETAILS_STEP",
    ADDRESS_VERIFICATION_STEP = "ADDRESS_VERIFICATION_STEP",
    DIRECTOR_DETAILS_STEP = "DIRECTOR_DETAILS_STEP",
    PROOF_OF_ADDRESS_STEP = "PROOF_OF_ADDRESS_STEP",
    END_PAGE_STEP = "END_PAGE_STEP",
  }

  export enum stepStatus {
    NOT_STARTED = "NOT_STARTED",
    PENDING = "PENDING",
    APPROVED = "APPROVED",
    REJECTED = "REJECTED",
  }
}
